import { Box, ButtonBase, ButtonBaseProps } from "@mui/material";
import { Iconify } from "app/components/Iconify";
import { createColorWithAlphaChannel } from "app/theme/helpers/createColorWithAlphaChannel";

import { Workspace } from "../types";
import { WorkspaceAvatar } from "./WorkspaceAvatar";
import { WorkspaceLabel } from "./WorkspaceLabel";

type WorkspaceButtonProps = ButtonBaseProps & {
  openPopover: (event: React.MouseEvent<HTMLButtonElement>) => void;
  selectedWorkspace: Workspace;
};

export const WorkspaceButton = ({
  openPopover,
  selectedWorkspace,
  sx,
  ...other
}: WorkspaceButtonProps) => {
  return (
    <ButtonBase
      disableRipple
      onClick={openPopover}
      sx={{
        bgcolor: (theme) =>
          createColorWithAlphaChannel(
            theme.vars.palette.grey["500Channel"],
            0.08,
          ),
        borderRadius: 1.5,
        gap: 1.5,
        justifyContent: "flex-start",
        pl: 2,
        pr: 1.5,
        py: 3,
        textAlign: "left",
        width: 1,
        ...sx,
      }}
      {...other}
    >
      <WorkspaceAvatar
        alt={selectedWorkspace?.name}
        src={selectedWorkspace?.logo}
      />

      <Box
        alignItems="center"
        display="flex"
        flexGrow={1}
        gap={1}
        sx={{ fontWeight: "fontWeightSemiBold", typography: "body2" }}
      >
        {selectedWorkspace?.name}
        <WorkspaceLabel label={selectedWorkspace?.label} />
      </Box>

      <Iconify
        icon="carbon:chevron-sort"
        sx={{ color: "text.disabled" }}
        width={16}
      />
    </ButtonBase>
  );
};
